/**
 * RequireRole — 라우트 역할 가드(PIN 대체, 2026-07-24).
 *
 * min="manager" 처럼 고정하거나, feature="contract" 로 접근 config(app_config/access)의
 * 최소역할을 따른다(사장이 직원 관리에서 조정 → 즉시 반영). 역할이 부족하면 안내 후 홈으로.
 * AUTH 미설정 모드에선 role=owner(기본값)라 항상 통과(기존 공용 비번 동작 그대로).
 */
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { roleAtLeast, ROLE_LABEL, minRoleFor, canAccess } from "./access";

export default function RequireRole({ min, feature, children }) {
  const { role, access, deny } = useAuth();
  const need = feature ? minRoleFor(access, feature) : min;
  const ok = feature ? canAccess(role, feature, access, deny) : roleAtLeast(role, need);
  if (ok) return children;   // 제외 포함(#56)

  return (
    <div className="ds-container" style={{ maxWidth: 460, margin: "0 auto", paddingTop: 96, textAlign: "center" }}>
      <div className="ds-card-soft" style={{ padding: 28, display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ fontSize: 40 }} aria-hidden>🔒</div>
        <div className="ds-list-item-title" style={{ fontSize: 18 }}>접근 권한이 없습니다</div>
        <p className="ds-list-item-meta" style={{ margin: 0 }}>
          이 화면은 <b>{ROLE_LABEL[need] || "관리자"}</b> 이상 전용입니다. 현재 계정 등급은 <b>{ROLE_LABEL[role] || "직원"}</b>입니다.
        </p>
        <Link to="/" className="ds-btn ds-btn-primary" style={{ textDecoration: "none" }}>홈으로</Link>
      </div>
    </div>
  );
}
